/**
 * @author: lv.chen
 * @date: 2026/5/18
 * @desc: GrowthRate 增长率显示组件演示文件
 */
import React from 'react';
import GrowthRate, { formatGrowthRate } from './index';

/**
 * Demo 案例配置
 * 每个配置项对应文档页面中的一个演示场景
 */
export const demoConfig = [
  {
    title: '上升趋势',
    description: '增长率为正值时，显示绿色文本和向上箭头',
    code: `<GrowthRate growthRate={formatGrowthRate(0.5)} />`,
    element: (
      <GrowthRate growthRate={formatGrowthRate(0.5)} />
    ),
  },
  {
    title: '下降趋势',
    description: '增长率为负值时，显示红色文本和向下箭头',
    code: `<GrowthRate growthRate={formatGrowthRate(-0.3)} />`,
    element: (
      <GrowthRate growthRate={formatGrowthRate(-0.3)} />
    ),
  },
  {
    title: '无数据状态',
    description: '增长率为 0 或 null 时，显示灰色文本，无箭头',
    code: `<GrowthRate growthRate={formatGrowthRate(0)} />`,
    element: (
      <GrowthRate growthRate={formatGrowthRate(0)} />
    ),
  },
  {
    title: '隐藏箭头图标',
    description: '设置 showIcon 为 false，不显示箭头图标',
    code: `<GrowthRate showIcon={false} growthRate={formatGrowthRate(0.5)} />`,
    element: (
      <GrowthRate showIcon={false} growthRate={formatGrowthRate(0.5)} />
    ),
  },
  {
    title: '空值不渲染',
    description: 'growthRate 为 null 时，组件返回 null，不渲染任何内容',
    code: `<GrowthRate growthRate={null} />`,
    element: (
      <GrowthRate growthRate={null} />
    ),
  },
];

export default demoConfig;
